import { serviceTypes, modulesConfig } from '../config';

export const moduleId = 'Orders';

export const modulePath = serviceTypes[modulesConfig[moduleId].serviceType].path;

export const pagePaths = {
  Module: modulePath,
};
